import type React from 'react'

export interface AvatarProps {
  readonly name: string
  readonly size?: 'sm' | 'md'
}

const sizeClasses: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'h-7 w-7 text-xs',
  md: 'h-9 w-9 text-sm',
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase()
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
}

export function Avatar({ name, size = 'md' }: AvatarProps): React.ReactElement {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-primary-soft font-medium text-primary ${sizeClasses[size]}`}
      aria-hidden="true"
    >
      {getInitials(name)}
    </span>
  )
}
